import React, { createContext, useContext } from 'react';

import { Route, Switch } from 'react-router-dom';

import TemplateList from './TemplateList/TemplateList';
import TemplateEditor from './containers/TemplateEditor';

const Template = ({ match }) => (
  <Switch>
    <Route exact path={`${match.url}/`} component={TemplateList} />
    <Route path={`${match.url}/editor/:id?`} component={TemplateEditor} />
  </Switch>
);

export default Template;

export { default as Preview } from './Preview/Preview';

export const TemplateContext = createContext();
export const useTemplate = () => useContext(TemplateContext);

export { default as TemplateSelectorDialog } from './Selector/TemplateSelectorDialog';
